module.exports = __webpack_public_path__ + "img/avcommentary_bottom_logo.c707b41f.png";